import * as React from 'react';
import './PartSmartView.scss';
import i18n from 'src/translation/i18n';
import partSmartServiceInstance from 'src/services/partsmart/partsmartService';
import { goToLogin, goToHome } from 'src/utils/navigation';
import partSmartIcon from 'src/assets/partSmart';
import Alert from 'src/components/common/Alert';

interface IWarrantyProps {
  t?: any;
  // currentTab: number;
  // selectTab: (index: number) => void;
}

const PartSmartView: React.FC<IWarrantyProps> = props => {
  const gblSuperId =localStorage.getItem('gblSuperId');
  const gblSuperEmail=localStorage.getItem('gblSuperEmail');

  const [apiLoader, handleApiLoader] = React.useState(false);
  const [showPartSmartLoginWindow, setShowPartSmartLoginWindow] = React.useState(false);
  const [clientIdentity, setClientIdentity] = React.useState(gblSuperId);
  const [clientEMail, setEmail] = React.useState(gblSuperEmail);
  const [error, setError] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);

  interface IPartSmartLoginResponse {
    access_token: string;
    refresh_token: string;
    expires_in: number;
  }

  const exactDomainRegex = /^[A-Za-z0-9._%+-]+@reliableparts\.com$/i;
  const validateEmail = (value: string) => {
    if (!value) {
      return "Please enter your email address.";
    }
    if (!exactDomainRegex.test(value)){
      return "Email address must be on the @reliableparts.com domain.";
    } 
    return "";
    };

  const handleEmailAddress =(event: any) =>{
    setEmail(event.target.value);
    setError(validateEmail(event.target.value));
  }

  const handleSubmit=(e: React.FormEvent)=> {
    e.preventDefault();
    const validationError = validateEmail(clientEMail);
    setError(validationError);
    if (validationError) {
      setSubmitted(false);
      return;
    }
    setSubmitted(true);
    handleApiLoader(true);
    localStorage.setItem('pUsr', clientIdentity);
    localStorage.setItem('pEmail', clientEMail);
    const superUserAccessToken=localStorage.getItem('accessSuperToken');
    const pUsr=clientIdentity;
    const pEmail=clientEMail;
    loadTokens(superUserAccessToken,pUsr, pEmail );
    }

  const loadTokens = async (superUserAccessToken: string, pUsr: string, pEmail:string) => {
   
    try{
      const response = await partSmartServiceInstance.getPartSmartLogin(
        superUserAccessToken,
        pUsr,
        pEmail
      );
      const r = response as IPartSmartLoginResponse;
          handleApiLoader(false);
          setShowPartSmartLoginWindow(false);
          const container = document.getElementById("partsmart-container");
         if (!r.access_token) {
            if (container) {
              container.innerHTML = ""; 
            }
           // goToHome();
            return null;
          }
            const script = document.createElement("script");
           // const expiresIn = 30;
            script.src = `https://www.partsmart.net/stream.js?access_token=${r.access_token}&refresh_token=${r.refresh_token}&expires_in=${r.expires_in}`;
            script.async = true;
           container.appendChild(script);
            return () => {
            //  clearTimeout(logoutTimer);
              script.remove();
              container.innerHTML = "";
            }; 

    }catch (error) {
    //  goToHome();
      console.error("Failed to fetch PartSmart token:", error);
      return null;
     }
  };

  

React.useEffect(() => {
    handleApiLoader(true);
    const superUserAccessToken=localStorage.getItem('accessSuperToken');
    const pUsr=localStorage.getItem('pUsr');
    const pEmail=localStorage.getItem('pEmail');
    if (pUsr === null || pUsr === "") {
      setShowPartSmartLoginWindow(true);
    }else{
      loadTokens(superUserAccessToken, pUsr, pEmail);
      setShowPartSmartLoginWindow(false);
    }
  }, []);

  return (
    showPartSmartLoginWindow ? (
      <section id="account-view">
      <div className="login-container">
          <div className="logo">
            <img src={partSmartIcon} alt="PartSmart Logo" />
          </div>
    
          <div className="heading">
            <p>Welcome to PartSmart</p>
            <p>Please sign in below to get started.</p>
          </div>
    
          {error && (
            <div className="sign-in--header">
              <Alert
                styleClass="errorPoNumberAlert"
                message={`${error}`}
                icon="rpds-error"
                handleCloseAlert={() => setError("")}
                type="error"
              />
            </div>
          )}
    
          <div className="form-container">
            <div className="input-group">
              <label>Username</label>
              <input
                type="text"
                id="email"
                value={clientIdentity}
                readOnly={true}
              />
            </div>
    
            <div className="input-group">
              <label>Email Address</label>
              <input
                type="text"
                id="password"
                value={clientEMail}
                onChange={handleEmailAddress}
              />
            </div>
    
            <button
              type="button"
              className="login-btn"
              onClick={handleSubmit}
            >
              LOGIN
            </button>
          </div>
        </div>
        </section>
    ):
    <div className="warranty-view">
      {apiLoader ? (
          <div className="loader-container">
            <div className="loader" />
          </div>
        ) : (
        <div id="partsmart-container"/>
      )}
    </div>
   
  )
};

export default PartSmartView;
